var app = angular.module("leonardo");

var GroupEditDialog = function($scope, $rootScope, FieldGroupService, FormErrorsService) {
  $scope.isEdit = !isNull($scope.ngDialogData.group);
  $scope.group = angular.copy($scope.ngDialogData.group);
  $scope.submit = function() {
    $scope.Form.$setSubmitted();

    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();

    if ($scope.isEdit) {
      $scope.group.patch(data).then(function (res) {
        updateAndClose(res);
      });
    }
    else {
      data.key = data.name.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-");
      FieldGroupService.post(data).then(function (result) {
        updateAndClose(result);
      });
    }
  };

  function updateAndClose(result) {
    FieldGroupService.updateCollection(result);
    $rootScope.$broadcast('group:changed');
    $scope.closeThisDialog();
  }

  $scope.getData = function() {
    return {
      name: $scope.group.name
    };
  };
};

app.controller('GroupEditDialog', ['$scope', '$rootScope', 'FieldGroupService', 'FormErrorsService', GroupEditDialog]);
